module.exports = __webpack_public_path__ + "7465bab0819fa7d2d1222e3ae94af0ea.fbx";